export default {
  CRM_URL:"http://www.kattgatt.com:8181"
}

export const CRM_URL="http://www.kattgatt.com:8181"